export const mapVideo = (video): Content.Video => {
	if (!video) {
		return null;
	}
	//TODO: remove when umbraco can return absolute urls for videos
	return {
		url: video.url,
		width: video.width,
		height: video.height,
		bytes: video.bytes,
		extension: video.extension,
	};
};

export const mapFirstVideo = (videos: Umbraco.Video[]): Content.Video => {
	if (!videos || videos.length === 0) {
		return null;
	}
	return mapVideo(videos[0]);
};

export const mapVideos = (videos: { video }[]): Content.Video[] => {
	if (!videos) {
		return null;
	}

	return videos.map((video) => {
		return mapVideo(video);
	});
};
